export const View = "view";
export const Edit = "edit";
export const Resolution = "resolution";
export const TakeOff = "take_off";
export const EditViewAll = "edit_view_all";
export const ViewAllEdit = "view_all_edit";
export const ViewEdit = "view_edit";
export const Administration = "administration";
